import { IconCheck, IconPlus } from "@tabler/icons-react";
import { useScrollCarousel } from "../../hooks/useScrollCarousel";
import { StoreCarouselNav } from "../StoreCarouselNav";
import { StorePrice } from "../StorePrice";
import { StoreStars } from "../StoreStars";
import styles from "./styles.module.scss";

export interface StoreCarouselProduct {
  id: number;
  name: string;
  image: string;
  originalAmount: number;
  finalAmount: number;
  selected: boolean;
  includedInCombo: boolean;
}

interface StoreProductCarouselProps {
  products: StoreCarouselProduct[];
  loading: boolean;
  error: boolean;
  search: string;
  onToggle: (product: StoreCarouselProduct) => void;
}

export function StoreProductCarousel({ products, loading, error, search, onToggle }: StoreProductCarouselProps) {
  const { trackRef, prev, next } = useScrollCarousel<HTMLUListElement>();

  return (
    <section className={styles.section} id="produtos" aria-labelledby="store-popular-title">
      <div className={styles.heading}>
        <h2 id="store-popular-title">Produtos mais populares</h2>
        <p>Os produtos mais procurados com preços especiais.</p>
      </div>

      {loading && <p className={styles.notice} role="status">Carregando produtos da loja…</p>}
      {error && <p className={styles.notice} role="alert">Não foi possível carregar os produtos agora. Tente novamente em instantes.</p>}
      {!loading && !error && products.length === 0 && (
        <p className={styles.notice}>{search ? `Nenhum produto encontrado para “${search}”.` : "Estamos preparando novidades para a loja."}</p>
      )}

      {products.length > 0 && <>
        <ul className={styles.track} ref={trackRef}>
          {products.map((product) => {
            const active = product.selected || product.includedInCombo;
            return (
              <li className={styles.card} key={product.id}>
                <div className={styles.image}>
                  <img src={product.image} alt={product.name} loading="lazy" decoding="async" />
                </div>
                <div className={styles.body}>
                  <h3>{product.name}</h3>
                  <StoreStars />
                  <StorePrice originalAmount={product.originalAmount} finalAmount={product.finalAmount} />
                  <button
                    className={styles.button}
                    type="button"
                    disabled={product.includedInCombo}
                    aria-pressed={product.selected}
                    onClick={() => onToggle(product)}
                    aria-label={product.includedInCombo ? `${product.name} incluído em um combo no carrinho` : product.selected ? `Remover ${product.name} do carrinho` : `Comprar ${product.name}`}
                  >
                    {active ? <IconCheck size={15} aria-hidden="true" /> : <IconPlus size={15} aria-hidden="true" />}
                    {product.includedInCombo ? "No combo" : product.selected ? "No carrinho" : "Comprar agora"}
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
        <StoreCarouselNav label="Produtos" onPrev={prev} onNext={next} />
      </>}
    </section>
  );
}
